<!-- Layout principal com formulário centralizado -->
<div class="new-password-container" #newPasswordContainer>
  <!-- Formulário de nova senha centralizado -->
  <div class="new-password-section">
    <div class="new-password-form">
      <div class="system-title">
        <h1 class="title">Nova Senha</h1>
      </div>
      <p class="sub-title">Defina sua nova senha de acesso</p>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Erro</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>

      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Sucesso!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>

      <!-- Formulário de nova senha -->
      <form *ngIf="!showMessages.success" (ngSubmit)="changePassword()" #form="ngForm" aria-labelledby="title">
        
        <!-- Campo da nova senha -->
        <div class="form-control-group">
          <label class="label" for="input-password">Nova Senha:</label>
          <nb-form-field>
            <input nbInput
              fullWidth
              [(ngModel)]="user.password"
              #password="ngModel"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              id="input-password"
              placeholder="Digite sua nova senha"
              fieldSize="large"
              [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
              required
              minlength="6"
              [attr.aria-invalid]="password.invalid && password.touched ? true : null"
              tabindex="1"
              autofocus>
            <button nbSuffix nbButton ghost 
              status="basic"
              type="button"
              (click)="togglePasswordVisibility()" 
              tabindex="-1"
              class="password-toggle-btn"
              [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
              <nb-icon [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'"
                      pack="eva">
              </nb-icon>
            </button>
          </nb-form-field>

          <ng-container *ngIf="password.invalid && password.touched">
            <p class="caption status-danger" *ngIf="password.errors?.required">
              Nova senha é obrigatória!
            </p>
            <p class="caption status-danger" *ngIf="password.errors?.minlength">
              A senha deve ter pelo menos 6 caracteres!
            </p>
          </ng-container>
        </div>

        <!-- Campo de confirmação da senha -->
        <div class="form-control-group">
          <label class="label" for="input-confirm-password">Confirmar Nova Senha:</label>
          <nb-form-field>
            <input nbInput
              fullWidth
              [(ngModel)]="user.confirmPassword"
              #confirmPassword="ngModel"
              name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="input-confirm-password"
              placeholder="Confirme sua nova senha"
              fieldSize="large"
              [status]="confirmPassword.dirty ? (confirmPassword.invalid ? 'danger' : 'success') : 'basic'"
              required
              [attr.aria-invalid]="confirmPassword.invalid && confirmPassword.touched ? true : null"
              tabindex="2">
            <button nbSuffix nbButton ghost 
              status="basic"
              type="button"
              (click)="toggleConfirmPasswordVisibility()" 
              tabindex="-1"
              class="password-toggle-btn"
              [attr.aria-label]="showConfirmPassword ? 'Ocultar senha' : 'Mostrar senha'">
              <nb-icon [icon]="showConfirmPassword ? 'eye-outline' : 'eye-off-2-outline'"
                      pack="eva">
              </nb-icon>
            </button>
          </nb-form-field>

          <ng-container *ngIf="confirmPassword.invalid && confirmPassword.touched">
            <p class="caption status-danger" *ngIf="confirmPassword.errors?.required">
              Confirmação de senha é obrigatória!
            </p>
          </ng-container>
          
          <!-- Aviso se as senhas não coincidem -->
          <ng-container *ngIf="user.password && user.confirmPassword && user.password !== user.confirmPassword">
            <p class="caption status-danger">
              As senhas não coincidem!
            </p>
          </ng-container>
        </div>

        <button nbButton
                fullWidth
                status="primary"
                size="large"
                [disabled]="submitted || !form.valid || user.password !== user.confirmPassword"
                [class.btn-pulse]="submitted"
                tabindex="3"
                class="change-password-btn">
          {{ submitted ? 'Alterando...' : 'Alterar Senha' }}
        </button>
      </form>

      <!-- Botões de navegação -->
      <div class="navigation-buttons">
        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="goBackToLogin()"
                class="login-btn">
          <nb-icon icon="log-in-outline" pack="eva"></nb-icon>
          Ir para Login
        </button>
      </div>

      <!-- Informações sobre a senha -->
      <div class="password-requirements">
        <h4 class="requirements-title">
          <nb-icon icon="info-outline" status="info"></nb-icon>
          Requisitos da Senha
        </h4>
        <ul class="requirements-list">
          <li class="requirement-item" [class.valid]="user.password && user.password.length >= 6">
            <nb-icon [icon]="user.password && user.password.length >= 6 ? 'checkmark-circle-outline' : 'close-circle-outline'" 
                     [status]="user.password && user.password.length >= 6 ? 'success' : 'basic'"></nb-icon>
            <span>Pelo menos 6 caracteres</span>
          </li>
          <li class="requirement-item" [class.valid]="user.password && user.confirmPassword && user.password === user.confirmPassword">
            <nb-icon [icon]="user.password && user.confirmPassword && user.password === user.confirmPassword ? 'checkmark-circle-outline' : 'close-circle-outline'" 
                     [status]="user.password && user.confirmPassword && user.password === user.confirmPassword ? 'success' : 'basic'"></nb-icon>
            <span>Senhas coincidem</span>
          </li>
        </ul>
      </div>

      <!-- Informações adicionais de segurança -->
      <div class="additional-info">
        <p class="info-text">
          <nb-icon icon="shield-outline" status="success"></nb-icon>
          <span>Sua nova senha será criptografada e armazenada com segurança.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="lock-outline" status="info"></nb-icon>
          <span>Recomendamos usar uma senha forte com letras, números e símbolos.</span>
        </p>
      </div>
    </div>
  </div>
</div>
